import React from "react";
import { Column } from "@/components/Datatable/types";
import { Button } from "@/components/ui/button";
import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import { Edit, Trash2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { AdminCatalogCategory } from "../../api/fetchCatalogCategories";

export function createCatalogCategoryColumns(
  onEdit: (category: AdminCatalogCategory) => void,
  onDelete: (category: AdminCatalogCategory) => void,
): Column<AdminCatalogCategory>[] {
  return [
    {
      header: "Name",
      accessorKey: "name",
      enableSorting: true,
    },
    {
      header: "Tagline",
      accessorKey: "tagline",
      cell: ({ row }) => (
        <span className="text-gray-500 dark:text-gray-400">
          {row.original.tagline || "--"}
        </span>
      ),
    },
    {
      header: "Sort",
      accessorKey: "sortOrder",
    },
    {
      header: "Products",
      accessorKey: "productCount",
    },
    {
      header: "Status",
      accessorKey: "isActive",
      cell: ({ row }) => (
        <span className="inline-flex items-center rounded bg-gray-100 dark:bg-slate-700 px-1.5 py-0.5 text-xs text-gray-600 dark:text-gray-300">
          {row.original.isActive ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              className="h-8 w-8 p-0 hover:bg-gray-200 transition-colors"
              variant="ghost"
            >
              <span className="sr-only">Open menu</span>
              <EllipsisVerticalIcon className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-[150px] p-2 bg-white">
            <DropdownMenuItem
              className="flex items-center px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 transition-colors"
              onClick={() => onEdit(row.original)}
            >
              <Edit className="mr-2 h-4 w-4" />
              <span>Edit</span>
            </DropdownMenuItem>
            <DropdownMenuItem
              className="flex items-center px-3 py-2 text-sm cursor-pointer text-red-600 hover:bg-gray-100 transition-colors"
              onClick={() => onDelete(row.original)}
            >
              <Trash2 className="mr-2 h-4 w-4" />
              <span>Delete</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      ),
    },
  ];
}
